import { Component, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { clearFiltersInit } from 'src/app/data/store/actions/filters.actions';
import { FiltersOptionsType } from 'src/app/data/store/models/filters.model';
import { removeChip } from 'src/app/shared/constants';
import { FiltersOptions, FiltersResetTypes, TextSizes, TextType } from 'src/app/shared/enums';

import { IonicModule } from '@ionic/angular';
import { TextComponent } from '../../../text/text.component';
import { ImageComponent } from '../../../image/image.component';
import { GetFullNamePipe } from '../../../../pipe/get-full-name/get-full-name.pipe';
@Component({
  selector: 'app-selected-filters',
  templateUrl: './selected-filters.component.html',
  styleUrls: ['./selected-filters.component.scss'],
  imports: [IonicModule, TextComponent, ImageComponent, GetFullNamePipe],
})
export class SelectedFiltersComponent {
  private _store = inject(Store);

  @Input() selectedOptionData?: any[] | null;

  @Input() selectedOptionName?: FiltersOptionsType;

  @Input() isChipDisable = false;

  @Input() isNeedExternalFiltersMenuCleaning = false;

  readonly TextSizes = TextSizes;

  readonly TextType = TextType;

  readonly removeChip = removeChip;

  readonly optionTypes = FiltersOptions;

  public removeElem(option?: FiltersOptionsType, id?: number) {
    this._store.dispatch(
      clearFiltersInit({
        activeFilterOption: option,
        id,
        clearType: FiltersResetTypes.deleteChip,
        isNeedExternalFiltersMenuCleaning: this.isNeedExternalFiltersMenuCleaning,
      }),
    );
  }
}
